export default "__VITE_ASSET__542770c5__"